import { createTelemetryAPI } from '~/utils/telemetry'

export const healthReportTelemetry = createTelemetryAPI(({ track }) => ({
  openHealthReportModal() {
    return track('Health Report: Open Modal')
  },
  viewReleaseNote() {
    return track('Health Report: View Health Rule Release Note')
  },
  viewReport(id: string) {
    return track('Health Report: View Report', { reportId: id })
  },
  generateOPReport(id: string) {
    return track('Health Report: Generate OP Report', { reportId: id })
  },
  generateCloudReport() {
    return track('Health Report: Generate Cloud Report')
  },
  regenerateReport(id: string) {
    return track('Health Report: Regenerate Report', { reportId: id })
  },
  deleteReport(id: string) {
    return track('Health Report: Delete Report', { reportId: id })
  },
  changeReportLang(lang: string) {
    return track('Health Report: Change Report Language', { lang })
  }
}))
